import gql from "graphql-tag";

export default gql`
  query UserNotes($issuerId: ObjectID!) {
    userNotes(issuerId: $issuerId) {
      _id
      objectId
      issuerId
      bodyAsJson
      bodyAsPlainText
    }
  }
`;
